export const MOLE_DASH_MAX_EXP = 5

export const SCORE_EXP_TIME = [
  { time: 30000, exp: 1 },
  { time: 60000, exp: 3 },
  { time: 90000, exp: 5 },
]
